import { AlertTriangle, Check, Info } from "lucide-react";
import { cn } from "@/lib/utils";

export const StatusIcon = ({ status, className = "size-6" }) => (
  <span className={cn("grid shrink-0 place-items-center rounded-full", className,
    status === "pass" && "bg-success text-white", status === "warn" && "bg-warning text-white", status === "todo" && "border-2 border-border")}
    aria-label={status === "pass" ? "Passed" : status === "warn" ? "Needs review" : "To do"} data-status={status}>
    {status === "pass" && <Check className="size-3.5" strokeWidth={3} />}
    {status === "warn" && <span className="text-xs font-bold leading-none">!</span>}
  </span>
);

export const PassBox = ({ children, testid }) => (
  <div className="flex items-start gap-2 rounded-xl bg-success/10 p-4 text-sm text-foreground" data-testid={testid}>
    <Check className="mt-0.5 size-4 shrink-0 text-success" strokeWidth={2.5} />
    <div className="min-w-0">{children}</div>
  </div>
);

export const FixBox = ({ children, testid, title = "Needs fixing" }) => (
  <div className="rounded-xl bg-warning/10 p-4 text-sm" data-testid={testid}>
    <p className="flex items-center gap-1.5 font-medium text-warning"><AlertTriangle className="size-4" /> {title}</p>
    <div className="mt-1 text-foreground">{children}</div>
  </div>
);

export const ErrorBox = ({ children, testid, className }) => (
  <div className={cn("rounded-xl bg-destructive/10 p-4 text-sm text-destructive", className)} data-testid={testid}>{children}</div>
);

export const Hint = ({ children, testid }) => (
  <p className="mt-1.5 flex items-start gap-1.5 text-xs text-muted-foreground" data-testid={testid}><Info className="mt-px size-3.5 shrink-0" />{children}</p>
);
